import React from "react";
import { Form } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const UploadMandateCell = ({ claim, uploadedFiles, handleFileUpload }) => {
   const { t } = useTranslation();
  if (claim.status === "Rejected") {
    return (
      <td>
        <span style={{ color: "gray" }}>{t("RejectedClaim")}</span>
      </td>
    );
  }

  if (claim.status === "Waiting for Admin Action") {
    return (
      <td>
        <span style={{ color: "gray" }}>{t("ViewAdmin")}</span>
      </td>
    );
  }

  if (claim.status === "Uploaded") {
    return <td><span className="text-info">{t("StartCollection")}</span></td>;
  }

  if (claim.mandateSkipped) {
    return (
      <td>
        {claim.document1 ? (
          <a
            href={`https://api-dashboard.nordmann-inkasso.de/${claim.document1.replace(/\\/g, "/")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary"
          >
            <FontAwesomeIcon icon={faFilePdf} className="me-2 text-danger" />
           {t("UploadedMandate")}
          </a>
        ) : (
          <span className="text-muted">No mandate document available</span>
        )}
      </td>
    );
  }

  if (claim.status === "Approved") {
    return (
      <td>
        <Form.Control
          type="file"
          accept="application/pdf"
          onChange={(e) => handleFileUpload(claim._id, e)}
        />
        {uploadedFiles[claim._id] && (
          <small className="text-success mt-1 d-block">
            {uploadedFiles[claim._id].name} selected
          </small>
        )}
      </td>
    );
  }

  return (
    <td>
      <a
        href={`https://api-dashboard.nordmann-inkasso.de/${claim?.document1?.replace(/\\/g, "/")}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary"
         style={{
          fontSize: "14px",
          fontWeight: "500",
          color: "#374151", // neutral dark gray
          background: "#f9fafb", // light SaaS bg
          padding: "6px 12px",
          borderRadius: "8px",
          border: "1px solid #e5e7eb",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#f3f4f6";
          e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#f9fafb";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        <FontAwesomeIcon icon={faFilePdf} className="me-2 text-danger" />
         {t("UploadedMandate")}
      </a>
    </td>
  );
};

export default UploadMandateCell;
